import Api from '../_redux/actions/api/_base';
import moment from 'moment';
import cookie from 'react-cookies';

export const handleLevelledSubmit = async (Address, Subscription, Levelled) => {
	const token = cookie.load('token');
	/*const mockLevelledData = {
		status: 'success',
		message: 'Code available to be redeemed',
		giftCode: {
			code: '9234567899900007853',
			id: '3',
			status: 'ACTIVATED',
			value: '179.70'
		},
		plan: {
			id: '11',
			signatureType: 'saude',
			value: '179.70',
			name: 'YALO Saúde Trimestral'
		}
	};*/
	const SubscriptionInfo = Subscription.data.itens[0];
	SubscriptionInfo.cpf = SubscriptionInfo.cpf.replace(/\D+/g, '');
	SubscriptionInfo.phone = SubscriptionInfo.phone.replace(/ |\-/g, '');
	const orderId = SubscriptionInfo.orderId;
	const planId = Levelled.plan.id;

	const giftCode = Levelled.giftCode;
	giftCode.value = Levelled.plan.value;
	const store = 'levelled';
	const subscriptor = {
		...SubscriptionInfo,
		birthDate: moment(SubscriptionInfo.birthday, 'DD-MM-YYYY').format(
			'YYYY-MM-DD'
		),
		address: Address
	};
	delete subscriptor.birthday;
	const data = {
		orderId,
		planId,
		subscriptor,
		giftCode,
		store
	};

	const response = await Api.post('/yalo/giftcode/redeem', data, token);

	return response.data;
};
